var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuIconBalancedLifestyle = function SvgMenuIconBalancedLifestyle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.059,
    height: 29,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#menu-icon-balanced-lifestyle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m27.094.57.023-.003c.135-.015.271-.016.38.078.173.148 2.475 4.694 2.785 5.29.548 1.052 1.135 2.097 1.653 3.163.035.071.064.143.07.222.013.215-.032.462-.065.674-.152.972-.526 1.867-1.196 2.602a4.67 4.67 0 0 1-3.3 1.538l-.025.001c-2.841.066-4.99-2.162-4.897-4.983.009-.244.578-1.22.724-1.49q.489-.925.988-1.845l2.04-3.805c.161-.298.633-1.248.82-1.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.31 10.703c.322.01.407.424.576.667.322.465.908.873 1.458.994-.034.173-.008.543-.104.643l-.09-.01c-.827-.208-1.671-.878-2.047-1.645-.158-.322-.124-.503.208-.649"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.184 0h1.345c-.003.103 0 .253-.078.333-.118.12-9.893 2.37-10.961 2.62.164.547.262 1.791.317 2.383q.191 2.117.339 4.238l.706 10.215c.13 1.892.236 4.007.44 5.881 1.681.359 3.557 1.41 3.611 3.33H10.62c.038-.465.102-.86.347-1.267.693-1.15 1.914-1.678 3.141-2.037-.01-.773.056-1.834.087-2.619q.136-3.274.357-6.544.222-3.808.51-7.612c.153-1.974.302-3.806.561-5.769-.683.178-1.45.336-2.143.498q-2.284.552-4.577 1.074-1.392.34-2.79.66c-.38.087-.771.193-1.151.268-.544.106-.829-.463-.156-.63.853-.21 1.712-.406 2.568-.606l4.812-1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.635 5.837c.32-.01.359.059.505.331.172.321.33.65.5.973.728 1.38 1.438 2.77 2.158 4.153l1.08 2.075c.184.35.586.976.6 1.345a4.74 4.74 0 0 1-1.99 4.017c-.819.581-1.579.801-2.567.863a6 6 0 0 1-.6-.016 4.64 4.64 0 0 1-3.148-1.63 4.87 4.87 0 0 1-1.144-3.356c.011-.221.565-1.19.702-1.451l1.241-2.374 1.75-3.342c.164-.31.68-1.4.913-1.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.822 16.056c.308.06.36.337.51.59.306.52.925.927 1.499 1.08-.017.153-.006.501-.099.613-.023.027-.094.008-.143.003-.875-.303-1.575-.796-1.99-1.649-.155-.32-.103-.505.223-.637"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu-icon-balanced-lifestyle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32.059v29H0z"
  })))));
};
export default SvgMenuIconBalancedLifestyle;